<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <changeLanguageHeaderTable
      :current-language="currentLanguage"
      @change-language="changeLanguage"
    />
    <BDataTable
      ref="refTable"
      :fetch-list="fetchList"
      :table-columns="tableColumns"
      @onGroupDelete="groupDelete"
    >
      <!-- Column: Actions -->
      <template #cell(actions)="{ item }">
        <edit-row @click.native="toEditPage(item._id)" />
        <delete-row @click.native="deleteItem(item._id)" />
      </template>
    </BDataTable>
  </div>
</template>

<script>
import 'bootstrap-vue'
import BDataTable from '@/components/BDataTable/index.vue'
import '@/components/BMediaCustom/index.vue'
import DeleteRow from '@/components/BDataTable/Actions/DeleteRow.vue'
import EditRow from '@/components/BDataTable/Actions/EditRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import changeLanguageHeaderTable from '@/components/change-language-header-table.vue'
import useArticleCategoriesList from './useArticleCategoriesList'

export default {
  name: 'ArticleCategoriesList',
  components: {
    BDataTable,
    DeleteRow,
    EditRow,
    LayoutLoading,
    changeLanguageHeaderTable,
  },
  setup() {
    const {
      changeLanguage,
      currentLanguage,
      deleteItem,
      fetchList,
      fetchCategoriesList,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
      fetchUsersByRole,
    } = useArticleCategoriesList()
    return {
      changeLanguage,
      currentLanguage,
      deleteItem,
      fetchList,
      fetchUsersByRole,
      fetchCategoriesList,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
    }
  },
  data() {
    return {
      searchT: '',
    }
  },
  watch: {
    searchT() {
      this.fetchCategoriesList(this.form.lang, this.searchT, '')
    },
  },
  created() {
    this.fetchUsersByRole({
      role: 'writer',
    }).then(res => {
      this.writerOptions = res
    })
    this.fetchCategoriesList()
  },
}
</script>
